import React from "react";

import { AutoComplete as BaseAutoComplete } from "antd";
import styled, { css } from "styled-components";
import color from "../_style/color";

import handleSpaces, { spacingProps } from "../utils/handleSpaces";

const OptionsWrapper = styled.div`
  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    background: unset !important;
  }
`;

const OptionRender = (options) => <OptionsWrapper>{options}</OptionsWrapper>;

const AutoComplete = styled(BaseAutoComplete).attrs((props) => ({
  filterOption: false,
  dropdownStyle: {
    border: `1px solid ${color.gainsboro}`,
    boxShadow: "unset",
    minWidth: "260px",
    width: "auto",
    ...props.dropdownStyles,
  },
  dropdownRender: props.dropdownRender || OptionRender,
  width: props.width || "100%",
  bordered: props.bordered || false,
  ...spacingProps(props),
}))`
  width: ${({ width }) => width};
  border: none;
  cursor: auto;

  ${({ bordered }) =>
    bordered &&
    css`
      border: none;
    `}

  ${(props) =>
    css`
      ${handleSpaces(props)}
    `}
`;

export default AutoComplete;
